import { checkIsMobile } from '../../../../../../common/utils';
import { UrlData } from '../../../../types';

export type LCUrlData = {
  tableId?: string;
} & UrlData;

export const handleReturnGameURL = (urlData: LCUrlData, sessionId?: string): string => {
  if (process.env.REACT_APP_GAME_LAUNCH_URL && sessionId) {
    const launchUrl = new URL(process.env.REACT_APP_GAME_LAUNCH_URL);

    launchUrl.searchParams.append('id', urlData?.id || '');
    launchUrl.searchParams.append('provider', 'TAIN_LIVE_CASINO');
    launchUrl.searchParams.append('operator', process.env.REACT_APP_OPERATOR_NAME || 'amazing');
    launchUrl.searchParams.append('channel', checkIsMobile() ? 'mobile' : 'desktop');
    launchUrl.searchParams.append('sessionId', sessionId);
    launchUrl.searchParams.append('tableId', urlData?.tableId || '');

    return launchUrl.href;
  }

  return '';
};
